import React from 'react';
import { StyledMediaCardSkeletonContainer, StyledMediaCardSkeletonHero, StyledMediaCardSkeletonLine } from './MediaCardSkeleton.styles.mjs';

const MediaCardSkeleton = () => {
    return (React.createElement(StyledMediaCardSkeletonContainer, { direction: "column", gap: "0.6rem" },
        React.createElement(StyledMediaCardSkeletonHero, null),
        React.createElement(StyledMediaCardSkeletonLine, { width: "82%" }),
        React.createElement(StyledMediaCardSkeletonLine, { width: "37%" })));
};

export { MediaCardSkeleton as default };
//# sourceMappingURL=MediaCardSkeleton.mjs.map
